import { gql } from '@apollo/client';

export const deleteLicenseTypeMutation = gql`
  mutation ($id: uuid!) {
    delete_license_types_by_pk(id: $id) {
      id
    }
  }
`;
